import { useEffect } from 'react';
import { getOnshapeAuthUrl } from '@/lib/onshape-auth';

/**
 * Onshape Login page - initiates OAuth flow
 * This page redirects to Onshape OAuth authorization
 */
export function OnshapeLogin() {
  useEffect(() => {
    try {
      // Immediately redirect to Onshape OAuth
      window.location.href = getOnshapeAuthUrl();
    } catch (error) {
      console.error('OAuth redirect error:', error);
      // Show error message on the page
      document.body.innerHTML = `
        <div style="min-height: 100vh; display: flex; align-items: center; justify-content: center; font-family: system-ui;">
          <div style="text-align: center; padding: 2rem;">
            <h1 style="color: #ef4444; margin-bottom: 1rem;">Configuration Error</h1>
            <p style="color: #6b7280; margin-bottom: 1rem;">${error.message}</p>
            <p style="color: #6b7280; font-size: 0.875rem;">
              Please create a <code>.env</code> file in the <code>web-app/</code> directory with:<br/>
              <code>VITE_ONSHAPE_CLIENT_ID=your_client_id_here</code>
            </p>
          </div>
        </div>
      `;
    }
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <p className="text-muted-foreground">Redirecting to Onshape...</p>
      </div>
    </div>
  );
}

